/**
 * @generated SignedSource<<b62c35739cfb1e268cea547d25697109>>
 * @relayHash 045139e2fb49e952256d811c3ddbcd4c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 045139e2fb49e952256d811c3ddbcd4c

import { ConcreteRequest } from 'relay-runtime';
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type deDuplicatePatientsByPatientIdQuery$variables = {
  patientId: string;
};
export type deDuplicatePatientsByPatientIdQuery$data = {
  readonly de_duplicatePatientsByPatientId: ReadonlyArray<{
    readonly displayId: number;
    readonly firstName: string;
    readonly gender: Gender;
    readonly id: string;
    readonly lastName: string;
  }>;
};
export type deDuplicatePatientsByPatientIdQuery = {
  response: deDuplicatePatientsByPatientIdQuery$data;
  variables: deDuplicatePatientsByPatientIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "concreteType": "DuplicatePatientOutput",
    "kind": "LinkedField",
    "name": "de_duplicatePatientsByPatientId",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gender",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deDuplicatePatientsByPatientIdQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deDuplicatePatientsByPatientIdQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "045139e2fb49e952256d811c3ddbcd4c",
    "metadata": {},
    "name": "deDuplicatePatientsByPatientIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c77ce75e679bd38e760bb40f3a1014aa";

export default node;
